import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'FAQ.title',
  },
  subTitle: {
    id: 'FAQ.subTitle',
  },
  AssuranceAuto: {
    id: 'faq.auto',
  },
  autoKeyword: {
    id: 'assurance_auto.keyword',
  },
  SinistreAuto: {
    id: 'sinistre_auto.title',
  },
  SinistreKeyword: {
    id: 'sinistre_auto.keyword',
  },
  AssuranceMrh: {
    id: 'faq.mrh',
  },
  MrhKeyWord: {
    id: 'assurance_mrh.keyword',
  },
  AssuranceEpargn: {
    id: 'faq.epargn',
  },
  epargnKeyword: {
    id: 'assurance_epargn.keyword',
  },
});
